// Chakra imports
import { Box, Icon, SimpleGrid, useColorModeValue } from "@chakra-ui/react";
// Custom components

import MiniStatistics from "components/card/MiniStatistics";
import IconBox from "components/icons/IconBox";
import { MdSell, MdAttachMoney } from "react-icons/md";
import { FaSortAmountUp } from "react-icons/fa";
import NumerariosCards from "./components/NumerarioCard";
import SellClientGraphic from "./components/SellclientGraphic";
import TickeMedioGraphic from "./components/TicketMedioGraphic";
import { useSell } from "hooks/SellHook";
import { useQuery } from "react-query";

export default function VendasPage() {
  // Chakra Color Mode
  const brandColor = useColorModeValue("brand.500", "white");
  const boxBg = useColorModeValue("secondaryGray.300", "whiteAlpha.100");

  const { findCardsTotalSalles } = useSell();
  const { data, isLoading, error } = useQuery(["findCardsTotalSalles"], () =>
    findCardsTotalSalles()
  );

  if (error) {
    return (
      <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
        <Box
          color="red.500"
          fontWeight="bold"
          fontSize="xl"
          textAlign="center"
          p={8}
        >
          {String(error)}
        </Box>
      </Box>
    );
  }

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, "2xl": 3 }}
        gap="20px"
        mb="20px"
      >
        <MiniStatistics
          loading={isLoading}
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon w="32px" h="32px" as={MdAttachMoney} color={brandColor} />
              }
            />
          }
          growth={data?.CARDS.PORCENTAGEM_VENDAS}
          name="Valor em vendas (R$)"
          value={
            data?.CARDS.VALOR_VENDAS
              ? data.CARDS.VALOR_VENDAS.toLocaleString("pt-br", {
                  currency: "BRL",
                })
              : 0
          }
        />

        <MiniStatistics
          loading={isLoading}
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={<Icon w="32px" h="32px" as={MdSell} color={brandColor} />}
            />
          }
          growth={data?.CARDS.PORCENTAGEM_TICKET_MEDIO}
          name="Ticket médio"
          value={
            data?.CARDS.TICKET_MEDIO
              ? data.CARDS.TICKET_MEDIO.toLocaleString("pt-br")
              : 0
          }
        />

        <MiniStatistics
          loading={isLoading}
          startContent={
            <IconBox
              w="56px"
              h="56px"
              bg={boxBg}
              icon={
                <Icon
                  w="32px"
                  h="32px"
                  as={FaSortAmountUp}
                  color={brandColor}
                />
              }
            />
          }
          name="Tickets"
          growth={data?.CARDS.PORCENTAGEM_QUANTIDADE_VENDAS}
          value={
            data?.CARDS.QUANTIDADE_VENDAS
              ? data.CARDS.QUANTIDADE_VENDAS.toLocaleString("pt-br")
              : 0
          }
        />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 2, lg: 2 }} gap="20px" mb="20px">
        <SellClientGraphic />
        <TickeMedioGraphic />
      </SimpleGrid>

      <SimpleGrid columns={{ base: 1, md: 1, lg: 1 }} gap="20px" mb="20px">
        <NumerariosCards />
      </SimpleGrid>
    </Box>
  );
}
